import React, { useMemo, useReducer } from 'react';
import PropTypes from 'prop-types';
import { KanbanContext } from 'context/Context';
import currentUserAvatar from 'assets/img/team/3.jpg';

import {
  members,
  labels,
  attachments,
  kanbanItems,
  comments,
  activities
} from 'data/kanban';
import { kanbanReducer } from 'reducers/kanbanReducer';

const KanbanProvider = ({ children, initialData, currentUserOverride }) => {
  const initData = useMemo(() => ({
    members: members,
    labels: labels,
    attachments: attachments,
    kanbanItems: kanbanItems,
    comments: comments,
    activities: activities,
    kanbanModal: {
      show: false,
      modalContent: {}
    }
  }), []);

  const mergedData = useMemo(() => ({ ...initData, ...(initialData || {}) }), [initData, initialData]);

  const defaultCurrentUser = {
    name: 'Emma',
    avatarSrc: currentUserAvatar,
    profileLink: '/user/profile',
    institutionLink: '#!'
  };

  const currentUser = currentUserOverride || defaultCurrentUser;

  const [kanbanState, kanbanDispatch] = useReducer(kanbanReducer, mergedData);

  return (
    <KanbanContext.Provider
      value={{ kanbanState, kanbanDispatch, currentUser }}
    >
      {children}
    </KanbanContext.Provider>
  );
};

KanbanProvider.propTypes = {
  children: PropTypes.node.isRequired,
  initialData: PropTypes.shape({
    members: PropTypes.array,
    labels: PropTypes.array,
    attachments: PropTypes.array,
    kanbanItems: PropTypes.array,
    comments: PropTypes.array,
    activities: PropTypes.array,
    kanbanModal: PropTypes.shape({
      show: PropTypes.bool,
      modalContent: PropTypes.object
    })
  }),
  currentUserOverride: PropTypes.shape({
    name: PropTypes.string,
    avatarSrc: PropTypes.string,
    profileLink: PropTypes.string,
    institutionLink: PropTypes.string
  })
};

export default KanbanProvider;
